/**
 * Redux Store
 */
import {applyMiddleware, createStore} from 'redux';
import {composeWithDevTools} from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
import reducers from '../reducers';
import RootSaga from '../sagas';
import {config} from "../config";
// create the saga middleware
const sagaMiddleware = createSagaMiddleware();

const middlewares = [sagaMiddleware];

export const configureStore = (initialState) => {
    const devTools =  config.isLocalhost ? composeWithDevTools(applyMiddleware(...middlewares)) : applyMiddleware(...middlewares);
    const store = createStore(reducers, initialState, devTools);
    let saga = sagaMiddleware.run(RootSaga);

    if (module.hot) {
        // Enable Webpack hot module replacement for reducers
        module.hot.accept('../reducers', () => {
            const nextRootReducer = require('../reducers/index');
            store.replaceReducer(nextRootReducer);
        });

        module.hot.accept('../sagas', () => {
            saga.cancel();
            saga.done.then(() => {
                saga = sagaMiddleware.run(RootSaga);
            });
        });
    }

    return store;
};
